import { Box, IconButton, Tooltip } from '@mui/material';
import type { ReactNode } from 'react';

export interface PmViewOption<T extends string> {
  value: T;
  label: string;
  icon: ReactNode;
}

interface PmViewToggleProps<T extends string> {
  value: T;
  onChange: (next: T) => void;
  options: PmViewOption<T>[];
}

/** PM-ViewToggle — segmentierter Button-Switch fuer mehrere Views (Tabelle/Tree/Mindmap/etc.). */
export function PmViewToggle<T extends string>({ value, onChange, options }: PmViewToggleProps<T>) {
  return (
    <Box
      sx={{
        display: 'inline-flex',
        background: 'var(--pm-bg-subtle)',
        border: '1px solid var(--pm-bg-deep)',
        borderRadius: 'var(--pm-radius)',
        padding: '2px',
      }}
    >
      {options.map((opt) => {
        const active = opt.value === value;
        return (
          <Tooltip key={opt.value} title={opt.label}>
            <IconButton
              size="small"
              onClick={() => onChange(opt.value)}
              sx={{
                color: active ? '#fff' : 'var(--pm-fg-muted)',
                background: active ? 'var(--rittec-petrol)' : 'transparent',
                borderRadius: '8px',
                px: 1.2,
                py: 0.5,
                '&:hover': {
                  background: active ? 'var(--pm-primary-hover)' : 'var(--pm-bg-muted)',
                  // Inaktiv: heller bg-muted-Hover -> Text muss mitschalten (sonst weiss auf hell im Light-Theme).
                  color: active ? '#fff' : 'var(--pm-fg-base)',
                },
              }}
            >
              {opt.icon}
            </IconButton>
          </Tooltip>
        );
      })}
    </Box>
  );
}
